import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 mt10 txt-center loading-footer" }
const _hoisted_2 = { class: "pl10 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "loading-dot",
  style: {"color":"var(--black-light)"}
}, "•••", -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.className, "row txt-center"])
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.sizes),
      class: "loader"
    }, null, 4),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.textLoading)), 1),
      _hoisted_3
    ], 512), [
      [_vShow, _ctx.isLoading]
    ])
  ], 2))
}